export default {
  default: () => import("/var/www/pecom.am/www/frontend/layouts/default.vue").then(m => m.default || m)
}